import React from 'react'

import Button from 'components/atoms/Button'
import Typography from 'components/atoms/Typography'
import { func } from 'prop-types'

const TermsModal = ({ action }) => (
  <div>
    <div className="terms-modal">
      <div className="terms-modal__wrapper">
        <div className="terms-modal__header">
          <Typography variant="subheading" component="div" fontWeight="bold" className="terms-modal__text">
            Persetujuan Pengguna
          </Typography>
        </div>
        <div className="terms-modal__body">
          <Typography variant="subbody" component="div" className="terms-modal__text">
            Apakah kamu bersedia mendapatkan informasi lebih detail terkait kampus yang telah kamu pilih?
          </Typography>
        </div>
        <div className="terms-modal__actions">
          <Button onClick={() => action(false)} className="terms-modal__btn" variant="secondary">Tidak Setuju</Button>
          <Button onClick={() => action(true)} className="terms-modal__btn">Setuju</Button>
        </div>
      </div>
    </div>
    <style jsx>
      {`
        .terms-modal {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.6);
          z-index: 99999;
          &__wrapper {
            position: fixed;
            border-radius: 10px;
            background-color: #fff;
            width: 90%;
            max-width: 576px;
            height: auto;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          &__header {
            padding: 16px 24px;
            border-bottom: 1px solid #e3ecf5;
          }
          &__body {
            padding: 24px;
          }
          :global(&__text) {
            color: #0c2846 !important;
          }
          &__actions {
            display: flex;
            justify-content: flex-end;
            column-gap: 8px;
            padding: 16px 24px;
            border-top: 1px solid #e3ecf5;
            @media screen and (min-width: 768px) {
              column-gap: 16px;
            }
          }
          :global(&__btn) {
            font-weight: bold;
            font-size: 12px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      `}
    </style>
  </div>
)

TermsModal.propTypes = {
  action: func,
}

export default TermsModal
